(function () {
  'use strict';
  var lightingTerms = new Set(['aquarium lighting', 'aquarium light', 'aquarium lights', 'fish tank light', 'fish tank lights', 'fish tank lighting']);
  function query(term) {
    var value = String(term || '').trim();
    return lightingTerms.has(value.toLowerCase()) ? '"aquarium" "lighting"' : value;
  }
  function href(term, root) {
    var params = new URLSearchParams({ q: query(term), type: 'product', 'options[prefix]': 'last', 'options[unavailable_products]': 'last' });
    return (root || '/') + 'search?' + params.toString();
  }
  window.YoloLifeSearch = { query: query, href: href };
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[role="search"]')) return;
    var input = form.querySelector('[name="q"]');
    if (!input || query(input.value) === input.value) return;
    event.preventDefault();
    var url = new URL(form.action, window.location.href);
    url.search = new URLSearchParams(new FormData(form)).toString();
    url.searchParams.set('q', query(input.value));
    url.searchParams.delete('page');
    window.location.assign(url.href);
  });
  function normalizeLegacySearch() {
    var gate = document.querySelector('[data-yl-search-normalize]');
    if (!gate) return;
    var url = new URL(window.location.href);
    if (url.searchParams.get('q') === gate.dataset.ylSearchNormalize) return;
    url.searchParams.set('q', gate.dataset.ylSearchNormalize);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('options[unavailable_products]', 'last');
    url.searchParams.delete('page');
    window.location.replace(url.href);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', normalizeLegacySearch, { once: true });
  else normalizeLegacySearch();
})();
